import React, { useEffect, useState } from 'react';
import { companyInfo } from '../mockData';
const Petal = ({ style }) => (
  <div style={{
    position: 'fixed',
    width: '12px',
    height: '16px',
    background: 'rgba(255,255,255,0.7)',
    borderRadius: '50% 0 50% 0',
    pointerEvents: 'none',
    zIndex: 0,
    ...style,
  }} />
);
const TermsOfService = () => {
  const [petals, setPetals] = useState([]);
  useEffect(() => {
    const generated = Array.from({ length: 18 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      animationDuration: `${6 + Math.random() * 8}s`,
      animationDelay: `${Math.random() * 8}s`,
      size: `${8 + Math.random() * 10}px`,
      opacity: 0.4 + Math.random() * 0.5,
      rotate: `${Math.random() * 360}deg`,
    }));
    setPetals(generated);
  }, []);
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0f 0%, #0d1117 40%, #0a0f1a 70%, #050508 100%)',
      fontFamily: "'Georgia', serif",
      color: '#6b2d4a',
      position: 'relative',
      overflowY: 'hidden',
    }}>
      <style>{`
        @keyframes petalFall {
          0% {
            transform: translateY(-60px) rotate(0deg) translateX(0px);
            opacity: 0;
          }
          10% { opacity: 1; }
          90% { opacity: 0.6; }
          100% {
            transform: translateY(110vh) rotate(720deg) translateX(60px);
            opacity: 0;
          }
        }
        @keyframes petalSway {
          0%, 100% { margin-left: 0px; }
          25% { margin-left: 20px; }
          75% { margin-left: -20px; }
        }
          footer {
            background: linear-gradient(135deg, #0a0a0f 0%, #1a0810 40%, #120a0f 70%, #050508 100%) !important;
            color: #c4567a !important;
          }
          footer a {
            color: #d4789a !important;
          }
            footer * {
            color: #e8789a !important;
          }
      `}</style>
      {/* Floating Petals */}
      {petals.map(petal => (
        <div key={petal.id} style={{
          position: 'fixed',
          left: petal.left,
          top: '-20px',
          width: petal.size,
          height: petal.size,
          background: 'rgba(255,255,255,0.75)',
          borderRadius: '50% 0 50% 0',
          pointerEvents: 'none',
          zIndex: 0,
          opacity: petal.opacity,
          animation: `petalFall ${petal.animationDuration} ${petal.animationDelay} infinite linear`,
          transform: `rotate(${petal.rotate})`,
          boxShadow: '0 2px 6px rgba(255,180,210,0.3)',
        }} />
      ))}
      {/* Soft bokeh circles */}
      <div style={{
        position: 'fixed', top: '-10%', right: '-5%',
        width: '400px', height: '400px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.25) 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
        borderRadius: '50%',
      }} />
      <div style={{
        position: 'fixed', bottom: '-15%', left: '-8%',
        width: '350px', height: '350px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
        borderRadius: '50%',
      }} />
      <div style={{ position: 'relative', zIndex: 1, maxWidth: '800px', margin: '0 auto', padding: '80px 24px' }}>
        {/* Header */}
        <div style={{ marginBottom: '60px' }}>
          <p style={{
            fontSize: '11px', letterSpacing: '4px', textTransform: 'uppercase',
            color: '#c47a95', marginBottom: '16px',
          }}>{companyInfo.name}</p>
          <h1 style={{
            fontSize: '48px', fontWeight: '300', letterSpacing: '-1px',
            background: 'linear-gradient(135deg, #8b1a4a 0%, #c4567a 40%, #e8789a 70%, #b03060 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            marginBottom: '16px', lineHeight: '1.1',
          }}>Terms of Service</h1>
          <div style={{
            width: '60px', height: '1px',
            background: 'linear-gradient(90deg, #d4789a, transparent)',
            marginBottom: '16px',
          }} />
          <p style={{ fontSize: '13px', color: '#c490a8', letterSpacing: '1px' }}>Last updated: March 2026</p>
        </div>
        {/* Intro */}
        <p style={{
          fontSize: '15px', lineHeight: '1.9', color: '#8b4060',
          marginBottom: '48px',
          padding: '24px 28px',
          border: '1px solid rgba(212,120,154,0.2)',
          borderLeft: '2px solid rgba(212,120,154,0.5)',
          background: 'rgba(225, 182, 210, 0.80)',
          borderRadius: '0 8px 8px 0',
          backdropFilter: 'blur(4px)',
        }}>
          By accessing and using the {companyInfo.name} website, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use this website.
        </p>
        {/* Sections */}
        {[
          {
            title: 'Use of Website',
            content: 'This website is intended for informational purposes only. You may use this site for lawful purposes and in a manner consistent with all applicable laws and regulations. You agree not to copy, reproduce, or distribute any content from this site without prior written permission.',
          },
          {
            title: 'Product Information',
            content: 'The product information provided on this website is for general informational purposes only and does not constitute medical advice. All pharmaceutical products should be used only as directed by a qualified healthcare professional. Consult your doctor or pharmacist before using any medication.',
          },
          {
            title: 'Intellectual Property',
            content: `All content on this website including text, logos, and graphics are the intellectual property of ${companyInfo.name} and are protected under applicable copyright and trademark laws. Unauthorized use or reproduction is strictly prohibited.`,
          },
          {
            title: 'Limitation of Liability',
            content: `${companyInfo.name} shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use or inability to use this website or its content. We make no warranties, expressed or implied, regarding the accuracy or completeness of information on this site.`,
          },
          {
            title: 'Third Party Links',
            content: 'This website may contain links to third-party websites for your convenience. We do not endorse or take responsibility for the content, privacy policies, or practices of any third-party sites. Visiting those links is at your own risk.',
          },
          {
            title: 'Changes to Terms',
            content: 'We reserve the right to update or modify these Terms of Service at any time without prior notice. Changes will be effective immediately upon posting to the website. Your continued use of the site after any changes constitutes your acceptance of the new terms.',
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: '40px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
              <span style={{
                fontSize: '10px', color: '#d4a0b8', fontFamily: 'monospace', letterSpacing: '1px',
              }}>0{i + 1}</span>
              <h2 style={{
                fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase',
                background: 'linear-gradient(90deg, #a03060, #d4789a)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                fontWeight: '600',
              }}>{section.title}</h2>
              <div style={{ flex: 1, height: '1px', background: 'rgba(212,120,154,0.2)' }} />
            </div>
            <p style={{ fontSize: '15px', lineHeight: '1.9', color: '#8b5070', paddingLeft: '28px' }}>
              {section.content}
            </p>
          </div>
        ))}
        {/* Contact */}
        <div style={{
          marginTop: '60px', padding: '32px',
          background: 'rgba(225, 182, 210, 0.80)',
          border: '1px solid rgba(212,120,154,0.2)',
          borderRadius: '12px',
          backdropFilter: 'blur(4px)',
        }}>
          <h2 style={{
            fontSize: '13px', letterSpacing: '2px', textTransform: 'uppercase',
            background: 'linear-gradient(90deg, #a03060, #d4789a)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            fontWeight: '600', marginBottom: '20px',
          }}>Contact Us</h2>
          <div style={{ fontSize: '14px', lineHeight: '2', color: '#8b5070' }}>
            <p style={{ color: '#6b2d4a', fontWeight: '500' }}>{companyInfo.name}</p>
            <p>{companyInfo.corporateOffice.address}</p>
            <p>Phone: <a href={`tel:${companyInfo.corporateOffice.phone}`} style={{ color: '#c4567a', textDecoration: 'none' }}>{companyInfo.corporateOffice.phone}</a></p>
            <p>Email: <a href={`mailto:${companyInfo.corporateOffice.email}`} style={{ color: '#c4567a', textDecoration: 'none' }}>{companyInfo.corporateOffice.email}</a></p>
          </div>
        </div>
        {/* Footer line */}
        <div style={{
          marginTop: '60px', paddingTop: '24px',
          borderTop: '1px solid rgba(212,120,154,0.2)',
          textAlign: 'center',
          fontSize: '11px', letterSpacing: '2px', color: '#d4a0b8',
          textTransform: 'uppercase',
        }}>
          © {new Date().getFullYear()} {companyInfo.name}
        </div>
      </div>
    </div>
  );
};
export default TermsOfService